import React, { Fragment, useState } from "react";
import useClickOutside from "./../../hooks/Screen/useClickOutside";

const DeleteConfirmModal = ({ onClose, onOpen, onSave, refetch }) => {
  const [selection, setSelection] = useState("this_recurrance_task");

  const handleSave = () => {
    onSave(selection);
  };

  const clickoutsideclose = useClickOutside(() => {
    onClose();
  });

  return (
    <Fragment>
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-[99999999999]">
        <div className="bg-white p-6 rounded-lg shadow-lg w-1/3 max-w-md" ref={clickoutsideclose}>
          <h2 className="text-xl font-semibold mb-4">Delete Event</h2>

          {/* Entire Recurring Task */}
          <div className="mb-4">
            <input
              type="radio"
              id="entireSeries"
              name="editOption"
              value="entire_recurring_task"
              checked={selection === "entire_recurring_task"}
              onChange={() => setSelection("entire_recurring_task")}
              className="mr-2 cursor-pointer"
              disabled
            />
            <label htmlFor="entireSeries">Delete entire series</label>
          </div>

          {/* This Recurrence Task */}
          <div className="mb-4">
            <input
              type="radio"
              id="thisOccurrence"
              name="editOption"
              value="this_recurrance_task"
              checked={selection === "this_recurrance_task"}
              onChange={() => setSelection("this_recurrance_task")}
              className="mr-2 cursor-pointer"
            />
            <label htmlFor="thisOccurrence">Edit this occurrence only</label>
          </div>

          {/* Future Recurring Tasks */}
          <div className="mb-6">
            <input
              type="radio"
              id="futureTasks"
              name="editOption"
              value="future_recurring_tasks"
              checked={selection === "future_recurring_tasks"}
              onChange={() => setSelection("future_recurring_tasks")}
              className="mr-2 cursor-pointer"
              disabled
            />
            <label htmlFor="futureTasks">Delete future occurrences</label>
          </div>

          <div className="flex justify-end space-x-4">
            <button onClick={handleSave} className="px-4 py-2 bg-primary-90 text-white rounded hover:bg-primary">
              Save
            </button>
            <button onClick={onClose} className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DeleteConfirmModal;
